<!--
 * @Descripttion: 
 * @Author: juanjuanhui
 * @Date: 2021-12-06 14:49:54
 * @LastEditors: juanjuanhui
 * @LastEditTime: 2022-05-03 10:49:40
-->
<template>
  <div class="map-top-info">
    <ul class="list">
      <!-- 可筛选 -->
      <template v-if="mapTopInfoOptions.isFilter">
        <li
          class="item cursor"
          v-for="(item, index) in mapTopInfoOptions.data"
          :class="item.id == checkedItem.id ? 'active' : ''"
          :key="index"
          @click="handleFilterMap(item)"
        >
          <template
            v-if="mapTopInfoOptions.hasAll && index == 0 && item.id == 11111"
            ><i class="icon" :class="item.icon"></i
            ><span class="name">{{ item.name }}</span></template
          >
          <template v-else>
            <i class="block" :style="{ background: item.colour }"></i
            ><span class="name">{{ item.name }}</span>
          </template>
        </li>
      </template>
      <!-- 不可筛选 -->
      <template v-else>
        <li
          class="item"
          v-for="(item, index) in mapTopInfoOptions.data"
          :key="index"
        >
          <i class="block" :style="{ background: item.colour }"></i
          ><span>{{ item.name }}</span>
        </li>
      </template>
      <li class="item-sel" v-if="hasShowTrajectoryBtn">
        <el-checkbox
          v-model="showTrajectoryVal"
          @change="changeShowTrajectory(showTrajectoryVal)"
          >作业轨迹</el-checkbox
        >
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      showTrajectoryVal: false,
      // showTrajectory: false, // 是否显示轨迹
      hasShowTrajectoryBtn: true, // 是否有显示轨迹按钮
      checkedItem: { id: 11111 }, // 选中的筛选项
    };
  },
  props: {
    // 顶部信息配置项
    mapTopInfoOptions: {
      type: Object,
      default: function () {
        return {
          hasAll: false,
          isFilter: false,
          data: [],
          hasData: true,
        };
      },
    },
  },
  computed: {
    ...mapState("map", {
      showTrajectory: (state) => state.showTrajectory,
    }),
  },
  watch: {
    showTrajectory(n) {
      // this.$bus.$emit("showTrajectory", n);
      this.changeShowTrajectory(n);
      this.showTrajectoryVal = n;
    },
    "checkedItem.id": {
      handler: function (n) {
        if (this.mapTopInfoOptions.hasData) {
          if (n == 11111) {
            this.hasShowTrajectoryBtn = false;
          } else {
            if (this.mapTopInfoOptions.hasShowTrajectoryBtn) {
              this.hasShowTrajectoryBtn = true;
            }
          }
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    ...mapActions("map", ["changeShowTrajectory"]),
    /**
     * @descripttion: 筛选地图
     * @Author: juanjuanhui
     * @Date: 2021-12-10 11:32:05
     * @param {*} item
     */
    handleFilterMap(item) {
      this.checkedItem = item;
      this.$bus.$emit("filterMap", item);
    },
  },
};
</script>

<style lang="scss" scoped>
.map-top-info {
  position: absolute;
  top: 0;
  left: 0;
  height: 46px;
  background-color: rgba($color: #000000, $alpha: 0.6);
  border-radius: 0px 0px 23px 0px;
  .list {
    display: flex;
    align-items: center;
    height: 100%;
    padding: 0 17px;
    .item {
      display: flex;
      align-items: center;
      position: relative;
      height: 100%;
      margin-right: 22px;
      color: #fefeff;
      &.cursor {
        cursor: pointer;
      }
      &.active {
        .name {
          border-bottom: 3px solid #fff;
        }
      }
      .name {
        display: inline-flex;
        align-items: center;
        height: 100%;
      }
      .icon {
        margin-right: 5px;
      }
      .block {
        width: 16px;
        height: 16px;
        margin-right: 5px;
      }
    }
    .item-sel {
      ::v-deep .el-checkbox {
        color: #018388;
        .el-checkbox__inner {
          width: 16px;
          height: 16px;
          border: solid 1px #018388;
          background-color: transparent;
          &::after {
            width: 4px;
            height: 8px;
            border-color: #018388;
          }
        }
        .el-checkbox__label {
          font-size: 16px;
        }
      }
    }
  }
}
</style>
